import { Module } from 'vuex'

type MyCredentialsStateType = {
  cacheRouteNames: Array<string>
}

export const MyCredentialsDetail = 'my-credentials-detail'
export const CredentialsDetail = 'credentials-detail'

const MyCredentials: Module<MyCredentialsStateType, any> = {
  namespaced: true,
  state: {
    cacheRouteNames: [MyCredentialsDetail],
  },
  mutations: {
    addCacheRouteName(state, cacheRouteName) {
      if (state.cacheRouteNames.find((_) => _ === cacheRouteName)) {
        return
      } else {
        state.cacheRouteNames.push(cacheRouteName)
      }
    },
    removeCacheRouteName(state, cacheRouteName) {
      console.log(
        'removeCacheRouteName',
        state.cacheRouteNames.filter((_) => _ !== cacheRouteName)
      )
      state.cacheRouteNames = state.cacheRouteNames.filter((_) => _ !== cacheRouteName)
    },
  },
  actions: {},
}

export default MyCredentials
